import { render, staticRenderFns } from "./addGreenProductsPreview.vue?vue&type=template&id=be650650&scoped=true&"
import script from "./addGreenProductsPreview.vue?vue&type=script&lang=js&"
export * from "./addGreenProductsPreview.vue?vue&type=script&lang=js&"
import style0 from "./addGreenProductsPreview.vue?vue&type=style&index=0&id=be650650&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be650650",
  null
  
)

export default component.exports